
import { useBrandManager } from "./useBrandManager";

export const useBrandSelection = () => {
  const { currentBrandId } = useBrandManager();
  
  return {
    currentBrandId
  };
};
